import { canEditCompanyDetails } from '~/entities/business/lib/company-details'
import { useSupabaseSession } from '~/entities/session/model/use-auth'

export const COMPANY_DETAILS_ANCHOR = 'rechnungsdaten'

export function useCanEditCompanyDetails(): boolean {
  const session = useSupabaseSession()
  const roles = (session?.user?.app_metadata?.roles as string[] | undefined) ?? []
  return canEditCompanyDetails(roles)
}
